import { format } from 'date-fns';
import { SimpleConfigBaseFilter } from 'gung-list';

export class EdiCreatedDateFilter<T extends { timestamp?: string | Date } = { timestamp?: string | Date }> extends SimpleConfigBaseFilter<T> {
  getName(): string {
    return 'Created in Gung';
  }
  getOptionIds(item: T): string[] {
    const timestamp = item.timestamp;
    if (timestamp == null || String(timestamp).trim() === '') {
      return [];
    }
    const date = new Date(timestamp);
    return Number.isNaN(date.getTime()) ? [] : [format(date, 'yyyy-MM-dd')];
  }
  getOptionName(key: string): string {
    return key;
  }
}
